import {
  Button,
  Checkbox,
  Collapse,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";

import React, { useEffect, useState } from "react";
import { useGetAllCategoriesQuery } from "../../../../Store/Slices/CategoriesSlice/categoriesApi";
import FilterListIcon from "@mui/icons-material/FilterList";
import SideBarSkeleton from "./SideBarSkeleton";
import SwitchButton from "./SwitchButton";
import { GradientBorderBox } from "../../../../Components";
import CatItems from "./CatItems";

export default function SideBar({ query, handleQuery, slug }) {
  const theme = useTheme();

  const [activePr, setActivePr] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [catsOpen, setCatsOpen] = useState({
    categories: query?.category ? true : false, // when clicked on دسته بندی ها
    mainCategories: query?.category, // when clicked on main categories it save code
    subCategories: false,
    subSubCategories: false,
  });
  const { data, isLoading, status } = useGetAllCategoriesQuery();

  // Slugs Changes Handle
  // Slugs Changes Handle
  useEffect(() => {
    setCatsOpen((prev) => ({
      ...prev,
      // اگر کوئری وجود داشت کادر اصلی باز بماند، در غیر این صورت وضعیت قبلی خودش را حفظ کند
      categories: query?.category ? true : prev.categories,

      mainCategories: query?.category
        ? query?.category == prev.subCategories ||
          query?.category == prev.subSubCategories
          ? prev.mainCategories
          : query?.category
        : prev.mainCategories, // اگر کوئری خالی شد، تغییری در وضعیت ایجاد نکن

      subCategories: query?.category
        ? query?.category == prev.subSubCategories
          ? prev.subCategories
          : query?.category
        : prev.subCategories, // اگر کوئری خالی شد، تغییری در وضعیت ایجاد نکن
    }));
  }, [query?.category]);
  // console.log("activePr", activePr);

  // show active Products
  const showActiveProducts = () => {
    setActivePr((prev) => {
      const newValue = !prev; // toggle
      handleQuery("exist", newValue); // send the correct value
      return newValue;
    });
  };

  // Mobile Filters
  const filters = [
    { label: "ارزان ترین", value: "cheapest" },
    { label: "گران ترین", value: "expensive" },
    // { label: "مرتبط ترین", value: "filter3" },
    { label: "جدید ترین", value: "newest" },
    { label: "پربازدید ترین", value: "visited" },
    { label: "پرفروش ترین", value: "best_seller" },
  ];
  const itemsFilter = filters?.map((e, index) => {
    return (
      <Stack
        key={index}
        sx={{
          transform: query.sortType == e?.value ? "scale(1.02)" : "",
          transition: "all .2s",
          mt: ".3rem",
          color: theme.palette.primary.main,
          bgcolor: theme.palette.background.cream,
          borderRadius: "6px",
          alignItems: "center",
          border: `1px solid ${
            query.sortType == e?.value
              ? theme.palette.primary.main
              : "transparent"
          }`,
          padding: "0.5rem 1rem",
          cursor: "pointer",
          position: "relative",
        }}
        onClick={() =>
          handleQuery("sortType", query.sortType == e?.value ? "" : e?.value)
        }
      >
        <Typography sx={{ whiteSpace: "nowrap" }}>{e?.label}</Typography>
        {query.sortType == e?.value ? null : (
          <GradientBorderBox
            bgGrad={`linear-gradient(
    90deg,
    ${theme.palette.background.paper} -30%,
    ${theme.palette.background.default} 50%,
    ${theme.palette.background.paper} 130%
  )`}
            radius=".3rem"
          />
        )}
      </Stack>
    );
  });
  if (isLoading || status !== "fulfilled") {
    return <SideBarSkeleton />;
  } else {
    return (
      <>
        <Stack
          direction={{ xs: "row", lg: "column" }}
          sx={{
            
            width: { xs: "auto", lg: "100%" },
            height: { xs: "300px", lg: "100%" },
            padding: ".5rem",
            color: theme.palette.primary.main,
            position: { xs: "absolute", lg: "static" },
            top: "120px",
            zIndex: "100",
            alignItems: "start",
            overflowX: "auto",
            maxWidth: { xs: "100%", lg: "100%" },
            gap: { xs: "1rem", lg: "2rem" },

            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          {/* Switch Button */}
          <SwitchButton
            showActiveProducts={showActiveProducts}
            activePr={activePr}
            handleQuery={handleQuery}
            query={query}
          />
          {/* Category Lists */}
          <Stack sx={{ width: "100%" }}>
            <Button
              color="secondary"
              sx={{
                fontSize: { xs: "1rem", md: "1.1rem" },
                justifyContent: "space-between",
                alignItems: "center",
                fontWeight: "bold",
                width: { xs: "170px", lg: "100%" },
                px: ".5rem",
                bgcolor: theme.palette.primary.main,
              }}
              onClick={() =>
                setCatsOpen({ ...catsOpen, categories: !catsOpen.categories })
              }
            >
              {"دسته بندی ها"}
              <ArrowLeftIcon
                sx={{
                  fontSize: { xs: "2rem", d: "2.5rem" },
                  transition: "all .2s",
                  transform: catsOpen?.categories ? "rotate(-90deg)" : "",
                }}
              />
            </Button>
            <Collapse
              sx={{
                width: { xs: "170px", lg: "100%" },
                maxHeight: { xs: "200px", lg: "100%" },
                overflow: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                position: "relative",
                // bgcolor:theme.palette.primary.lowOpacity
              }}
              in={catsOpen?.categories}
              timeout={500}
            >
              <CatItems
                catsOpen={catsOpen}
                data={data}
                handleQuery={handleQuery}
                query={query}
                setCatsOpen={setCatsOpen}
              />
            </Collapse>
          </Stack>

          {/* Mobile Filters */}
          <Stack
            sx={{
              display: { xs: "flex", lg: "none" },
            }}
          >
            <Button
              color="secondary"
              sx={{
                fontSize: { xs: "1rem", md: "1.1rem" },
                justifyContent: "space-between",
                alignItems: "center",
                width: { xs: "170px", lg: "100%" },
                px: ".5rem",
                direction: "ltr",
                bgcolor: theme.palette.primary.main,
              }}
              onClick={() => setFilterOpen(!filterOpen)}
            >
              <FilterListIcon
                sx={{
                  fontSize: { xs: "2rem", d: "2.5rem" },
                  fontWeight: "bold",
                }}
              />
              <Typography
                sx={{
                  whiteSpace: "nowrap",
                  fontSize: "1.1rem",
                  fontWeight: "bold",
                }}
              >
                مرتب سازی
              </Typography>
            </Button>
            <Collapse
              sx={{ width: { xs: "170px", lg: "100%" } }}
              in={filterOpen}
              timeout={500}
            >
              {itemsFilter}
            </Collapse>
          </Stack>
        </Stack>
        {/* H1 */}
        <Typography
          component={"h1"}
          variant="h6"
          sx={{
            color: theme.palette.primary.main,
            fontWeight: "bold",
            textAlign: "center",
            mb: "1rem",
            display: { xs: "flex", lg: "none" },
            position: "absolute",
            top: { xs: "72px", sm: "82px" },
            left: "50%",
            transform: "translate(-50%)",
          }}
        >
          محصولات نی موبایل
        </Typography>
      </>
    );
  }
}
